import { render, staticRenderFns } from "./BindTipsDialog.vue?vue&type=template&id=6ed4ab7b&scoped=true"
import script from "./BindTipsDialog.vue?vue&type=script&lang=js"
export * from "./BindTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./BindTipsDialog.vue?vue&type=style&index=0&id=6ed4ab7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed4ab7b",
  null
  
)

export default component.exports